import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_41848_7282)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M9.34364 7.65369C8.87488 8.59122 7.93735 9.52874 6.99986 9.99751C6.0623 9.52874 5.12478 8.59122 4.65601 7.65369",
				stroke: "#42296E",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7 4.00159V9.97191",
				stroke: "#42296E",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.96 10.2679C1.03941 10.9714 1.35481 11.6272 1.85476 12.1284C2.35472 12.6296 3.00973 12.9467 3.713 13.0279C4.783 13.1479 5.88 13.2499 7 13.2499C8.12 13.2499 9.218 13.1479 10.287 13.0279C10.9903 12.9467 11.6453 12.6296 12.1452 12.1284C12.6452 11.6272 12.9606 10.9714 13.04 10.2679C13.154 9.20488 13.25 8.11288 13.25 6.99988C13.25 5.88688 13.154 4.79488 13.04 3.73088C12.9606 3.02741 12.6452 2.37159 12.1452 1.87037C11.6453 1.36914 10.9903 1.05208 10.287 0.970878C9.217 0.852878 8.12 0.749878 7 0.749878C5.88 0.749878 4.782 0.851878 3.713 0.971878C3.00973 1.05308 2.35472 1.37014 1.85476 1.87137C1.35481 2.37259 1.03941 3.02841 0.96 3.73188C0.846 4.79388 0.75 5.88588 0.75 6.99988C0.75 8.11388 0.846 9.20488 0.96 10.2679Z",
				stroke: "#42296E",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_41848_7282",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 14,
			fill: "white"
		})
	}) })]
});
export default SvgDownload;
